<template>
  <v-app>
    <loader-component :show="routeLoading || loginLoading"/>
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loaderComponent from "./components/loaderComponent.vue";
export default {
  components:{loaderComponent},
  computed: {
    ...mapGetters({
      user: "profileModules/getUser", 
      routeLoading: "settingModules/isLoading", 
      loginLoading: "loginModules/isLoading", 
    }),
  },
  methods: {
    ...mapActions({
      verifyToken: "authModules/verifyToken",
      logout: "loginModules/logoutUser",
    }),
  },
  async created() {
    if (this.user) {
      try {
        await this.verifyToken();
      } catch (err) {
        await this.logout();
        this.$router.replace({ name: "login" });
      }
    }
  },
};
</script>
